import { render, staticRenderFns } from "./PersonPreview.vue?vue&type=template&id=e11751d8&scoped=true&"
import script from "./PersonPreview.vue?vue&type=script&lang=js&"
export * from "./PersonPreview.vue?vue&type=script&lang=js&"
import style0 from "./PersonPreview.vue?vue&type=style&index=0&id=e11751d8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11751d8",
  null
  
)

export default component.exports